<template>
  <div class="house-types-table-component">
    <div class="filters mb-4 d-flex flex-wrap align-items-end">
      <div class="form-group me-3 mb-25">
        <label for="search" class="me-2">Search</label>
        <input
          v-model="search"
          type="text"
          class="form-control"
          id="search"
          @keyup.enter="getHouseTypes()"
          :disabled="loading"
        />
      </div>

      <button
        @click="getHouseTypes()"
        type="button"
        class="btn btn-primary mb-25"
        :disabled="loading"
      >
        Search
      </button>

      <button
        v-if="filters"
        @click="resetFilters()"
        type="button"
        class="ms-3 mb-25 btn btn-danger"
      >
        Reset Filters
      </button>

      <a href="/admin/house_types/create" class="ms-3 mb-25 btn btn-success"
      >Create</a>

      <div v-if="loading" class="ms-3 mb-25 spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div class="developments-table" v-if="houseTypes.data">
      <div class="development border mb-2" v-for="houseType in houseTypes.data" :key="houseType.id">
        <div class="row">
          <div class="col col-md-5 ps-0">
            <div class="d-flex align-items-center position-relative"><img
              :src="'/storage/'+houseType.image "
              alt="Brook Meadow" width="160" height="120" class="development__image object-fit-cover">
              <h5
                class="mb-0 development__title">
                {{ houseType.name }} <span v-if="houseType.revision" class="text-muted">({{ houseType.revision }})</span><br>
                <small>ID: {{ houseType.id }}</small>
              </h5>
            </div>
          </div>
          <div class="col-12 col-md-3  border-left-0 d-flex align-items-center">

          </div>
          <div class="col-12 col-md">
            <div class="d-flex align-items-center justify-content-center  h-100 position-relative"><h5
              class="mb-0 text-center development__stat">
              {{ houseType.bedrooms }}<br> <small>Bedrooms</small></h5>
            </div>
          </div>
          <div class="col-12 col-md">
            <div class="d-flex align-items-center justify-content-center h-100 position-relative"><h5
              class="mb-0 text-center development__stat">
              {{ houseType.bathrooms }}<br> <small>Bathrooms</small></h5>
            </div>
          </div>
          <div class="col flex-grow-0 p-0">
            <div
              class="d-flex align-items-center justify-content-center flex-column h-100 position-relative development__actions development__actions--single">
              <a
                :href="'/admin/house_types/' + houseType.id + '/edit'"
                class="development__edit" title="Edit"
              ><i
                class="far fa-pencil"></i></a>

              <a
                :href="'/admin/house_types/' + houseType.id + '/floorplans'"
                class="development__floorplans" title="Floorplans"
              ><i class="far fa-ruler-triangle"></i></a>

            </div>
          </div>
        </div>
      </div>
    </div>

    <nav>
      <pagination
        :data="houseTypes"
        @pagination-change-page="getHouseTypes"
        :limit="2"
      ></pagination>
    </nav>


    <p class="text-muted">
      Found a total of
      {{ Number(houseTypes.total).toLocaleString() }} result(s).
    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      search: null,
      page: 1,
      houseTypes: null,
      filters: null,
    };
  },

  props: {
    preloadHouseTypes: {
      type: Object,
      default: null,
    },
  },

  created() {
    this.houseTypes = this.preloadHouseTypes;

    // Load get params.
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get("filters[search]")) {
      this.search = urlParams.get("filters[search]");
    }

    this.setFilters();
  },

  methods: {
    setFilters() {
      if (this.search !== null) {
        this.filters = {
          search: this.search,
        };
      } else {
        this.filters = null;
      }
    },

    handlePushState() {
      let pageUrl = "?";

      // Add filters.
      for (const filter in this.filters) {
        if (this.filters[filter] === null) {
          continue;
        }

        if (pageUrl !== "?") {
          pageUrl += "&";
        }

        pageUrl += `filters[${filter}]=${encodeURIComponent(
          this.filters[filter]
        )}`;
      }

      // Add page number.
      if (this.page > 1) {
        pageUrl += "&page=" + this.page;
      }

      window.history.pushState("", "", pageUrl);
    },

    getHouseTypes(page = 1) {
      this.loading = true;
      this.page = page;
      this.setFilters();

      this.handlePushState();

      axios
        .post(`${window.api_url}/admin/house_types/get`, {
          page: this.page,
          filters: this.filters,
        })
        .then((res) => {
          this.houseTypes = res.data.house_types;
        })
        .catch((err) => {
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    resetFilters() {
      this.search = null;
      this.getHouseTypes();
    },
  },
};
</script>
